import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";

function Footer({ isStaff }) {
  return (
    <footer>
      <div className="container footer-container">
        <div className="links">
          <div className="link">
            <h4 className="link-title">Sections</h4>
          </div>

          {!isStaff && (
            <>
              <ul>
                <li>
                  <a className="anchor" href="#landing">
                    Landing page
                  </a>
                </li>
                <li>
                  <a className="anchor" href="#trailer">
                    Trailer
                  </a>
                </li>
                <li>
                  <a className="anchor" href="#features">
                    Features
                  </a>
                </li>
              </ul>
            </>
          )}
          <div className="link">
            <h4 className="link-title">Social Media</h4>
            <ul>
              <li>
                <a
                  className="anchor"
                  href="https://discord.gg/8S7y3gTPNZ"
                  target="_blank"
                >
                  Discord
                </a>
              </li>
            </ul>
          </div>
          <div className="link">
            <h4 className="link-title">Useful links</h4>
            <ul>
              <li>
                <Router>
                  {isStaff ? (<Link className="anchor" to="/">
                    About Diamond-Pe
                  </Link>):
                  (<Link className="anchor" to="/staff">
                    About Staff
                  </Link>)
                  }
                </Router>
              </li>
              <li>
                <a
                  className="anchor"
                  href="https://minecraftpocket-servers.com/server/122269/vote/"
                  target="_blank"
                >
                  Vote Us
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p className="copyright__text">Copyright © 2023 diamond pe</p>
          <a href="https://discord.com/invite/XHpZ7xutQN" target="_blank">
            <button className="btn copyright-btn">Made by WebZone</button>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
